import { render } from "./PageBiayaPelunasan.vue?vue&type=template&id=2dfa31b0"
import script from "./PageBiayaPelunasan.vue?vue&type=script&lang=js"
export * from "./PageBiayaPelunasan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__